import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { FileText, Eye } from 'lucide-react';

const fmt = (d) => (d ? d.slice(0, 10).split('-').reverse().join('/') : '—');

// HISTÓRICO DE INTERNAÇÕES E PRONTUÁRIOS — uma linha por internação (inclusive encerradas)
export const HistoricoProntuarios = ({ pacienteId, internacaoAtualId }) => {
  const { api } = useAuth();
  const navigate = useNavigate();
  const [h, setH] = useState(null);
  useEffect(() => { if (pacienteId) api.get(`/internacoes/historico/${pacienteId}`).then((r) => setH(r.data)).catch(() => setH({ internacoes: [] })); }, [api, pacienteId]);
  if (!h) return null;
  return (
    <Card className="mt-4" data-testid="historico-prontuarios">
      <CardHeader className="pb-2"><CardTitle className="text-base flex items-center gap-2"><FileText className="h-4 w-4" />Histórico de Internações e Prontuários <span className="text-xs font-normal text-muted-foreground">{h.total_internacoes} internação(ões) · {h.readmissoes} readmissão(ões)</span></CardTitle></CardHeader>
      <CardContent className="p-0 overflow-x-auto">
        <Table><TableHeader><TableRow><TableHead>Nº Prontuário</TableHead><TableHead>Admissão</TableHead><TableHead>Alta</TableHead><TableHead>Status</TableHead><TableHead>Diagnóstico</TableHead><TableHead>Médico</TableHead><TableHead className="text-center">Dias</TableHead><TableHead className="text-center">Guias</TableHead><TableHead className="text-center">Docs</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {h.internacoes.map((i) => (
              <TableRow key={i.id} className={i.id === internacaoAtualId ? 'bg-primary/5' : ''} data-testid={`hist-prontuario-${i.id}`}>
                <TableCell className="font-mono text-xs">{i.numero_prontuario || '—'}{i.readmissao && <Badge variant="outline" className="ml-1 text-[10px] text-amber-700 border-amber-300">Readmissão</Badge>}</TableCell>
                <TableCell>{fmt(i.data_internacao)}</TableCell><TableCell>{fmt(i.data_alta)}</TableCell>
                <TableCell><Badge className={i.status === 'ativa' ? 'bg-emerald-100 text-emerald-800' : 'bg-slate-100 text-slate-700'}>{i.status === 'ativa' ? 'Ativa' : 'Alta'}</Badge></TableCell>
                <TableCell className="max-w-[220px] truncate" title={i.diagnostico_principal}>{i.diagnostico_principal || '—'}</TableCell>
                <TableCell>{i.medico_nome || '—'}</TableCell>
                <TableCell className="text-center">{i.dias}</TableCell><TableCell className="text-center">{i.guias}</TableCell><TableCell className="text-center">{i.documentos}</TableCell>
                <TableCell>{i.id !== internacaoAtualId && <Button size="sm" variant="ghost" onClick={() => navigate(`/pacientes/${pacienteId}/internacao/${i.id}`)} data-testid={`btn-ver-prontuario-${i.id}`}><Eye className="h-4 w-4" /></Button>}</TableCell>
              </TableRow>
            ))}
          </TableBody></Table>
      </CardContent>
    </Card>
  );
};
